import {registerRoute as workbox_routing_registerRoute} from '/Users/basti/WebstormProjects/feezal/node_modules/workbox-routing/registerRoute.mjs';
import {CacheFirst as workbox_strategies_CacheFirst} from '/Users/basti/WebstormProjects/feezal/node_modules/workbox-strategies/CacheFirst.mjs';
import {skipWaiting as workbox_core_skipWaiting} from '/Users/basti/WebstormProjects/feezal/node_modules/workbox-core/skipWaiting.mjs';
import {clientsClaim as workbox_core_clientsClaim} from '/Users/basti/WebstormProjects/feezal/node_modules/workbox-core/clientsClaim.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








workbox_core_skipWaiting();

workbox_core_clientsClaim();



workbox_routing_registerRoute("polyfills/*.js", new workbox_strategies_CacheFirst(), 'GET');




